import React, { useState } from 'react';
import '../App.css';
import Select from 'react-select';
import axios from 'axios';
import cookie from 'react-cookies';

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

import {
	useStripe,
	useElements,
	CardNumberElement,
	CardCvcElement,
	CardExpiryElement
} from "@stripe/react-stripe-js";

const Buyxchange = props => {
	const stripe = useStripe();
	const elements = useElements();

	const [payment, setPayment] = useState('');
	const [message, setMessage] = useState('');
	const [xchangeAmount, setAmount] = useState('');
	const [cardholderName, setCardholder] = useState('');
	const [email, setEmail] = useState('');
	const [flag_card, setFlagCard] = useState(false);
	const [currentPaymentPlan, setCurrentPaymentPlan] = useState({ value: 'card', label: 'Card' });
		
	const paymentList = [
				{ value: 'card', label: 'Card' }
			];

	const paymentChangeHandler = value => {
		setPayment(value.value);
		setCurrentPaymentPlan(value);

		if (value.value === "card") {
			setFlagCard(true);
		} else {
			setFlagCard(false);
		}
	}

	const cardHolderChangeHandler = e => {
		setCardholder(e.target.value);
	}
	
	const emailChangeHandler = e => {
		setEmail(e.target.value);
	}

	const xchangeAmountChangeHandler = (e) => {
		if (e.target.validity.valid) {
			setAmount(e.target.value);
		}
	}	
	
	const submitBuyXchange = async event => {
		event.preventDefault();

		if (!stripe || !elements || !cardholderName || !email || !xchangeAmount) {
			return;
		}

		if (xchangeAmount < 5) {
			setMessage("The minimum of Xchange amount is 5.");
			return;
		}
		
		const payload = await stripe.createPaymentMethod({
			type: "card",
			card: elements.getElement(CardNumberElement),
			billing_details: {
				name: cardholderName,
				email: email
			}
		});
		
		if (payload) {
			const data = {
				amount: xchangeAmount,
				payment_method: payload.paymentMethod.id,
				description: "Buy Xchange on DigitXchange"
			}

			axios.defaults.withCredentials = true;
			axios.post(window.$backend_url + '/get_paymentIntent', data)
				.then(response => {
					stripe.confirmCardPayment(response.data.client_secret, {
						payment_method: payload.paymentMethod.id,
					})
					.then(function(result) {
						if (result.paymentIntent.status == "succeeded") {
							const payment_data = {
								type: 2,
								userId: cookie.load('cookieId'),
								payment_option: 'card',
								intent_id: result.paymentIntent.id,
								intent_status: result.paymentIntent.status,
								amount: result.paymentIntent.amount,
								cardholder: cardholderName,
								email: email
							}

							axios.post(window.$backend_url + '/add_payment', payment_data)
								.then(response => {
									props.closeBuyXchange();
								})
								.catch(error => {
									console.log(error);
								})
						}
					})
				})
				.catch(error => {
					console.log(error);
				})
		}
	}

	const options = {
		style: {
			base: {
				color: "#ffd33f",
				letterSpacing: "0.025em",
				fontSize: "1rem",
				fontFamily: "Source Code Pro, monospace",
				"::placeholder": {
					color: "#808080"
				}
			},
			invalid: {
				color: "#9e2146"
			}
		}
	};	
	
	const customStyles = {
		control: styles => ({ 
			...styles,
			backgroundColor: '#313131',
			color: '#ffd33f',
			border: 'solid 1px #64541c',
			boxShadow: 'none',
			outline: 'none',
			"&:hover": {
				border: 'solid 1px #ffd33f',
				color: 'white',
				outline: 'none',
				boxShadow: 'none'
			},
			"&:focus": {
				border: 'solid 1px #ffd33f',
				color: 'white',
				outline: 'none',
				boxShadow: 'none'
			}
		}),
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			return {
				backgroundColor: isFocused ? '#ddd' : 'white',
				color: isFocused ? 'black' : 'gray',
				padding: '10px',
				size: 5,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			};
		},
		container: (base, state) => ({
			...base,
			border: state.isFocused ? null : null,
			"&:hover": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			},
			"&:focus": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			}
		}),
		singleValue: (provided, state) => ({
			...provided,
			color: "#ffd33f",
			"&:hover": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			},
			"&:focus": {
				border: 'none',
				boxShadow: 'none',
				outline: 'none'
			}
		})
	}

	return(
		<div className="modal-buy-subscription custom-modal">
			<div className="modal-logo">
				<img alt="logo" src="/assets/images/logo.png" />
			</div>
			<h2 className="text-center">{props.dataLanguage['buyXchange']}</h2>
			<form className="login-form">
				{ message ?
					<p className="message-text">{ message }</p>
				: null }
				<div className="form-group">
					<label>{props.dataLanguage['xchange_amount']}</label>
					<div className="user-container xchangeAmount">
						<input type="text" pattern="[0-9]*" value={xchangeAmount} onChange={xchangeAmountChangeHandler} className="form-control" />
					</div>
				</div>
				<div className="form-group">
					<div className="flex">
						<label>{props.dataLanguage['payment_options']}</label>
						<div className="payment_cards text-right">
							<img alt="coin" src="/assets/images/cards.png" />
						</div>
					</div>
					<Select styles={customStyles} options={paymentList} value={currentPaymentPlan} onChange={paymentChangeHandler} placeholder={props.dataLanguage['select']} />
				</div>
				<div className="stripe_form">
						<label>
							{props.dataLanguage['card_number']}
							<CardNumberElement
								options={options}
							/>
						</label>
						<div className="row">
							<div className="col-6">
								<label>
									{props.dataLanguage['cvc']}
									<CardCvcElement
										options={options}
									/>
								</label>
							</div>
							<div className="col-6">
								<label>
									{props.dataLanguage['expiration_date']}
									<CardExpiryElement
										options={options}
									/>
								</label>
							</div>
						</div>
				</div>
				<div className="form-group">
					<label>{props.dataLanguage['cardholder_name']}</label>
					<input value={cardholderName} onChange={cardHolderChangeHandler} type="text" className="form-control card" name="card" />
				</div>
				<div className="form-group">
					<label>{props.dataLanguage['email']}</label>
					<div className="user-container">
						<input value={email} onChange={emailChangeHandler} type="email" className="form-control useremail" name="useremail" />
					</div>
				</div>
				<button onClick={submitBuyXchange} type="submit" className="btn-submit">{props.dataLanguage['submit_order']}</button>					 
			</form>
		</div>
	)
	
}

export default Buyxchange;


// WEBPACK FOOTER //
// ./src/components/Buyxchange.js